export const actionTypes = {
  UPDATE_LOADING_PLAY_AUDIO_STATUS: 'UPDATE_LOADING_PLAY_AUDIO_STATUS',
  UPDATE_PLAY_AUDIO_BUTTON_ID: 'UPDATE_PLAY_AUDIO_BUTTON_ID',
  UPDATE_PLAY_AUDIO_LINK: 'UPDATE_PLAY_AUDIO_LINK',
  UPDATE_PLAY_AUDIO_REQUEST_ID: 'UPDATE_PLAY_AUDIO_REQUEST_ID',
  UPDATE_PLAYING_AUDIO_STATUS: 'UPDATE_PLAYING_AUDIO_STATUS',
  RESET_PREVIEW_AUDIO: 'RESET_PREVIEW_AUDIO',
};

const updateLoadingPlayAudioStatus = (status) => ({
  type: actionTypes.UPDATE_LOADING_PLAY_AUDIO_STATUS,
  status,
});

const updatePlayingAudioStatus = (status) => ({
  type: actionTypes.UPDATE_PLAYING_AUDIO_STATUS,
  status,
});

const updatePlayAudioButtonId = (id) => ({
  type: actionTypes.UPDATE_PLAY_AUDIO_BUTTON_ID,
  id,
});

const updatePlayAudioLink = (audioLink) => ({
  type: actionTypes.UPDATE_PLAY_AUDIO_LINK,
  audioLink,
});

const updatePlayAudioRequestId = (requestId) => ({
  type: actionTypes.UPDATE_PLAY_AUDIO_REQUEST_ID,
  requestId,
});

const resetPreviewAudio = () => ({
  type: actionTypes.RESET_PREVIEW_AUDIO,
});

export {
  updateLoadingPlayAudioStatus,
  updatePlayingAudioStatus,
  updatePlayAudioButtonId,
  updatePlayAudioLink,
  updatePlayAudioRequestId,
  resetPreviewAudio,
};
